import Address from './Address';

export default class DriverMetrics {
    metricsType: MetricsType;
    location: DriverGeolocation;
    address: Address;
    driver: DriverDetails;
    trailerId?: string | null;
    customerId?: string | null;
    locationId?: string | null;
    reservationReason?: string | null;

    constructor(
        metricsType: MetricsType,
        location: DriverGeolocation,
        address: Address,
        driver: DriverDetails,
        trailerId?: string | null,
        customerId?: string | null,
        locationId?: string | null,
        reservationReason?: string | null
    ) {
        this.metricsType = metricsType;
        this.location = location;
        this.address = address;
        this.driver = driver;
        this.trailerId = trailerId;
        this.customerId = customerId;
        this.locationId = locationId;
        this.reservationReason = reservationReason;
    }
}

export class DriverGeolocation {
    lat: number;
    lng: number;
    locationSource: LocationSource;

    constructor(lat: number, lng: number, locationSource: LocationSource) {
        this.lat = lat;
        this.lng = lng;
        this.locationSource = locationSource;
    }
}

export class DriverDetails {
    driverCode: string;
    truckNumber: string;
    company: string;

    constructor(driverCode: string, truckNumber: string, company: string) {
        this.driverCode = driverCode;
        this.truckNumber = truckNumber;
        this.company = company;
    }
}

export enum LocationSource {
    DEVICE_GPS = 0,
    TRUCK = 1,
    TRAILER = 2,
}

export enum MetricsType {
    NO_TRAILERS = 0,
    RESERVATION_EXPIRE = 1,
    ATTACH_TO_RESERVATION_FROM_NON_FREIGHTBOX_SOURCE = 2,
    RESERVATION_CREATED = 3,
}
